/*
 * Authors: mariushirjanu
 * Created: 27/11/2023
 */
import * as _ from 'underscore';
import { ILogPayload, LogLevel, RemoteLoggerDataService } from '../services/logger/remote-logger-data.service';
import { MemoryStorageService, STORAGE_LOGGER_PAYLOAD } from '../services/storage/memory-storage.service';
import { util } from '../util';

const LOGGER_SEND_INTERVAL = 120; // the time interval, measured in seconds, for sending the log to the server.

export function remoteLoggerInitializer(
  memoryStorageService:MemoryStorageService,
  remoteLoggerDataService:RemoteLoggerDataService,
  window:Window
) {
  let intervalId:number;

  const deleteSentLogEntries = (logEntriesSent:ILogPayload[]) => {
    let logEntries:ILogPayload[] = _.clone(memoryStorageService.get(STORAGE_LOGGER_PAYLOAD));
    _.each(logEntriesSent, (logEntrySent:ILogPayload) => {
      logEntries = _.without(logEntries, _.findWhere(logEntries, { timestamp: logEntrySent.timestamp }));
    });

    if(logEntries?.length > 0){
      memoryStorageService.set(STORAGE_LOGGER_PAYLOAD, logEntries);
    } else {
      memoryStorageService.remove(STORAGE_LOGGER_PAYLOAD);
    }
  };

  const sendLog = () => {
    const logPayload:ILogPayload[] = memoryStorageService.get(STORAGE_LOGGER_PAYLOAD);

    if (logPayload?.length) {
      remoteLoggerDataService.logBrowserDetails(logPayload, LogLevel.ERROR)
        .then(() => {
          deleteSentLogEntries(logPayload);
        })
        .catch(util.noop);
    }
  };

  return () => {
    window.clearInterval(intervalId);
    intervalId = window.setInterval(sendLog, LOGGER_SEND_INTERVAL * 1000);
  };
}